/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { UnGuard } from "constants/interfaces";
import { GetTripsResponse } from "lib/tripsApiTypes";

import { Avatar, Text } from "components";
import { useTranslation } from "react-i18next";

const Passengers = ({
  flight,
  trip,
}: {
  trip?: UnGuard<GetTripsResponse["approved_trips"]>[number];
  flight: UnGuard<
    UnGuard<GetTripsResponse["approved_trips"]>[number]["flights"]
  >[number];
}) => {
  const { t } = useTranslation();
  return trip?.companions?.length ? (
    <div className="mb-5">
      <Text className="-text--theme-colors-text-subtitle-brand text-sm">
        {t("flightForm.passengersLabel")}
      </Text>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-2">
        <div className="flex gap-x-2.5 items-center">
          <div className="w-[45px] h-[45px]  shrink-0 border rounded-full -border--theme-colors-border-neutral-11">
            <Avatar
              className="h-full w-full object-cover rounded-full"
              src={flight.user?.image}
              alt="companion-img"
            />
          </div>

          <div className="flex flex-col w-36">
            <Text className="-text--theme-colors-text-body whitespace-nowrap truncate">
              {flight.user?.first_name} {flight.user?.last_name}
            </Text>
          </div>
        </div>

        {flight.companions?.map((companion) => {
          return (
            <div className="flex gap-x-2.5 items-center">
              <div className="w-[45px] h-[45px]  shrink-0">
                <Avatar
                  className="h-full w-full object-cover rounded-full"
                  src={companion.image}
                  alt="companion-img"
                />
              </div>

              <div className="flex flex-col w-36">
                <Text className="-text--theme-colors-text-body whitespace-nowrap truncate">
                  {companion.first_name} {companion.last_name}
                </Text>
                <Text className="text-font-primary">
                  {companion.relationship}
                </Text>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  ) : null;
};

export default Passengers;
